module.exports = __webpack_public_path__ + "static/media/jumping_for_joy.a2eed178.jpg";